module.exports = __webpack_public_path__ + "img/alka_seltzer_plus_powermax_cough.30a36a27.png";